// vendor plugins
import VueClipboard from '@cycloidio/v-clipboard'
import { VueChleb } from '@cycloidio/vue-chleb'
import vMdEditor from './v-md-editor'
import Sentry from './sentry'
import PortalVue from 'portal-vue'

// vendor styles
import 'rappid/style'

// cycloid plugins
import Wasm from './wasm'
import browserTabTitle from './browser-tab-title'
import columnsResizable from './columns-resizable'
import DateFns from './date-fns'
import docsUrl from './docs-url'
import ECharts from './echarts'
import evaluateUserActions from './evaluate-user-actions'
import findTranslation from './find-translation'
import fixAutofillRendering from './fix-autofill-rendering'
import getSlug from './get-slug'
import globalMapGetters from './global-mapgetters'
import GoogleTagManager from './google-tag-manager'
import hasRightsTo from './has-rights-to'
import header from './header'
import hoverSiblings from './hover-siblings'
import isCreationRoute from './is-creation-route'
import Lodash from './lodash'
import placements from './placements'
import Rappid from './rappid'
import resetData from './reset-data'
import sanitizeHtml from './sanitize-html'
import sanitizeUrl from './sanitize-url'
import shortid from './shortid'
import toggle from './toggle'
import cycloidPlugin from './vue-cycloid-plugin'

/** Plugins to be applied before any others */
const priorityPlugins = [
  placements,
]

const plugins = [
  ...priorityPlugins,
  PortalVue,
  Sentry,
  Wasm,
  ECharts,
  VueClipboard,
  Rappid,
  Lodash,
  VueChleb,
  GoogleTagManager,
  DateFns,
  vMdEditor,
  // cycloid plugins
  browserTabTitle,
  columnsResizable,
  cycloidPlugin,
  fixAutofillRendering,
  docsUrl,
  findTranslation,
  getSlug,
  globalMapGetters,
  hasRightsTo,
  header,
  isCreationRoute,
  resetData,
  sanitizeHtml,
  sanitizeUrl,
  shortid,
  toggle,
  evaluateUserActions,
  hoverSiblings,
]

/**
 * Install plugins
 *
 * @param {import('vue').App} Vue
 * @returns {void}
 */
export function installPlugins (Vue) {
  plugins.forEach((plugin) => {
    const { name, options } = plugin
    if (!!name && !!options) Vue.use(name, options)
    else Vue.use(plugin)
  })
}
